import React, { useRef, useState } from 'react';
import { Anchor } from '@miro-site/ui-foundation';
import { OffCanvasLanguageList } from './off-canvas-language-list/off-canvas-language-list';
import { OverlayLanguageList } from './overlay-language-list/overlay-language-list';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LanguageSelector = function LanguageSelector(_ref) {
  var onChangeLocale = _ref.onChangeLocale,
      selectedValue = _ref.selectedValue,
      title = _ref.title,
      items = _ref.items;

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  var target = useRef(null);

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleSelect = function handleSelect(value) {
    var _items$find;

    var locale = ((_items$find = items.find(function (item) {
      return item.label === value;
    })) === null || _items$find === void 0 ? void 0 : _items$find.locale) || '';
    onChangeLocale === null || onChangeLocale === void 0 ? void 0 : onChangeLocale(locale);
  };

  if (items.length <= 1) {
    /**
     * If there is only one language, we don't need to show the language selector.
     */
    return null;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: "d-flex justify-content-around align-items-center gap-100",
    children: [/*#__PURE__*/_jsx(Anchor, {
      ref: target,
      iconEnd: "Globe",
      onClick: function onClick() {
        return setShow(!show);
      },
      children: selectedValue
    }), /*#__PURE__*/_jsx(OffCanvasLanguageList, {
      className: "d-flex d-md-none",
      selectedValue: selectedValue,
      show: show,
      handleSelect: handleSelect,
      handleClose: handleClose,
      title: title,
      items: items
    }), /*#__PURE__*/_jsx(OverlayLanguageList, {
      handleClose: handleClose,
      selectedValue: selectedValue,
      show: show,
      handleSelect: handleSelect,
      title: title,
      items: items,
      target: target
    })]
  });
};